import GraficaGastosContainer from "./GraficaGastosContainer"

export default GraficaGastosContainer